const red = "#ec3255"
const redHover = "#FF0008"
const blue = "#5596c1"
const green = "#23a682"
const orange = "#ff8c42"
const purple = "#9d66c7"
const gray = "#777"
const disabled = "rgba(16, 16, 16, 0.3)"
export { blue, disabled, gray, green, orange, purple, red, redHover }
